import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import { Modal, Button, Rating } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddRating({ open, onClose, setOpen }: ModalProps) {
  const [value, setValue] = useState<number | null>(0);

  return (
    <Modal className="modal addReply_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          {/* Title Bar */}
          <div className="modal_title">
            <h2>Add Rating</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          {/* Form Section */}
          <form className="form">
            {/* ⭐ Rating Section */}
            <div className="control_group">
              <label>Rating</label>
              <Rating
                name="rating-stars"
                value={value}
                onChange={(_, newValue) => setValue(newValue)}
                className="starrating"
                style={{ fontSize: "26px" }}
                icon={<StarIcon fontSize="inherit" />}
                emptyIcon={<StarIcon fontSize="inherit" />}
              />
            </div>

            {/* Review Text */}
            <div className="control_group">
              <label>Add Review</label>
              <TextField
                placeholder="Enter Review"
                fullWidth
                hiddenLabel
                multiline
                minRows={4}
              />
            </div>

            {/* Footer Buttons */}
            <div className="footer_btn_flex">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setOpen(false);
                }}
              >
                Submit
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
}
